import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useUpdateGdprStatusMutation } from '../../services/UserAPI';
import { useTranslation } from 'react-i18next';
import Style from '../../styles/components/layout/GDPRBanner.module.scss';

const GDPRBanner: React.FC = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const location = useLocation();

  const [updateGdpr] = useUpdateGdprStatusMutation();
  const { user, jwt } = useSelector((state: any) => state.Auth);
  const isLoggedIn = !!jwt && !!user;
  const isForbiddenPage = ['/', '/login'].includes(location.pathname);

  useEffect(() => {
    const localConsent = localStorage.getItem('activital_gdpr_status');
    const strapiConsent = user?.gdpr_status; 

    if (isLoggedIn && !isForbiddenPage) {
      setShow(!localConsent || strapiConsent === 'pending');
    } else {
      setShow(false);
    }
  }, [location.pathname, user, jwt, isLoggedIn, isForbiddenPage]);

  const handleChoice = async (choice: 'accepted' | 'declined') => {
    localStorage.setItem('activital_gdpr_status', choice);
    setShow(false);

    if (user?.id) {
      try {
        await updateGdpr({ id: user.id, gdpr_status: choice }).unwrap();
        console.log(`GDPR synchronisé via RTK Query : ${choice}`);
      } catch (error) {
        console.error("Erreur synchro RTK Query :", error);
      }
    }
  };

  if (!isLoggedIn || isForbiddenPage) return null;

  return (
    <>
      {!show && (
        <button onClick={() => setShow(true)} className={Style.floatingBtn} title="Paramètres">
          <span>⚙️</span> 
        </button>
      )}

      {show && (
        <div className={Style.container}>
          <div className={Style.content}>
            <div style={{ flex: 1 }}>
              <h4 className={Style.title}>{t('gdpr_title')}</h4>
              <p className={Style.desc}>
                {t('gdpr_message')}
                <br />
                <span style={{ fontSize: '0.75rem', color: '#718096', display: 'block', marginTop: '4px' }}>
                  {t('gdpr_submessage')}
                </span>
              </p>
            </div>
            <div className={Style.btnGroup}>
              <button onClick={() => handleChoice('declined')} className={`${Style.btnBase} ${Style.btnDecline}`}>
                {t('gdpr_decline')}
              </button>
              <button onClick={() => handleChoice('accepted')} className={Style.btnBase}>
                {t('gdpr_accept')}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GDPRBanner;